module.exports = __webpack_public_path__ + "static/media/mBishop.777fe424.jpeg";